"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.langMetadata = exports.Lang = void 0;
var Lang;
(function (Lang) {
    Lang["NL"] = "nl";
    Lang["EN"] = "en";
    Lang["DE"] = "de";
    Lang["FR"] = "fr";
    Lang["IT"] = "it";
    Lang["ES"] = "es";
    Lang["PT"] = "pt";
    Lang["JA"] = "ja";
    Lang["ZH"] = "zh";
})(Lang = exports.Lang || (exports.Lang = {}));
exports.langMetadata = {
    [Lang.NL]: {
        flag: "🇳🇱",
    },
    [Lang.EN]: {
        flag: "🇬🇧",
    },
    [Lang.DE]: {
        flag: "🇩🇪",
    },
    [Lang.FR]: {
        flag: "🇫🇷",
    },
    [Lang.IT]: {
        flag: "🇮🇹",
    },
    [Lang.ES]: {
        flag: "🇪🇸",
    },
    [Lang.PT]: {
        flag: "🇵🇹",
    },
    [Lang.JA]: {
        flag: "🇯🇵",
    },
    [Lang.ZH]: {
        flag: "🇨🇳",
    },
};
//# sourceMappingURL=Lang.js.map